import { Tooltip } from 'antd'
import showLoggerModal from './showLoggerModal'

const Logs = ({ orchestrator, uid }) => {
  return (
    <Tooltip
      mouseEnterDelay={1}
      title="Show the logs for this job"
      placement="right"
    >
    <a onClick={() => showLoggerModal(orchestrator, uid)}>Show Logs</a>
  </Tooltip>
  )
}

export default Logs
